<template>
  <div class="container-renwu" v-if="$store.state.isManager">
    <div class="tabs">
      <div class="tab select">打卡带看</div>
      <div class="tab" @click="gotoRenwu">带看任务</div>
    </div>

    <div class="select-type">
      <span>选择类型</span>
      <div class="control">
        <select v-model="type">
          <option selected value="1">新房</option>
          <option selected value="2">二手房</option>
          <option value="3">租房</option>
        </select>
      </div>
    </div>
    <div class="select-type">
      <span>打卡方式</span>
      <div class="control">
        <select v-model="method">
          <option selected value="1">本人带看打卡</option>
          <option value="2">替人带看打卡</option>
        </select>
      </div>
    </div>
    <div class="input-phone">
      <select v-model="dk_method">
        <option selected value="phone">手机号</option>
        <option value="bianhao">客户编号</option>
      </select>
      <!-- <span>手机号</span> -->
      <input
        type="text"
        v-if="dk_method == 'phone'"
        placeholder="请输入客户手机号"
        v-model="phone"
        @input="inputChangePhone($event)"
      />
      <input
        type="text"
        v-if="dk_method == 'bianhao'"
        placeholder="请输入客源编号"
        v-model="phone"
      />
    </div>
    <div class="select-type" v-if="dk_method == 'phone' && keyuanNum != null">
      <span>客源编号</span>
      <div class="control">
        {{ keyuanNum }}
      </div>
    </div>

    <div class="from-item" v-if="method == 2">
      <span class="from-lable">替看人</span>
      <div class="from-control">
        <input
          type="text"
          placeholder="请输入经纪人姓名"
          :value="name"
          @input="inputChange($event)"
        />
      </div>
    </div>
    <div class="list" v-if="method == 2 && list.length > 0">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="select(item)"
      >
        <span class="name">{{ item.login_name }}</span>
      </div>
    </div>

    <div class="btn-commit" @click="commit">确认打卡</div>
    <div>
      <van-action-sheet
        v-model="show"
        :actions="keyuanList"
        cancel-text="取消"
        title="请选择客源编号"
        close-on-click-action
        @cancel="onCancel"
        @select="onSelect"
      />
    </div>
  </div>
  <div v-else class="container-renwu no">暂无权限</div>
</template>


<script>
import util from "../../common/util.js";
import actions from "../../common/actions.js";
import { Dialog } from "vant";
export default {
  data() {
    return {
      method: "1",
      type: "2",
      dk_method: "phone",
      phone: "",
      name: "",
      list: [],
      user: null,
      show: false,
      keyuanList: [],
      keyuanNum: null,
    };
    stor;
  },
  created() {
    this.$store.commit("changeTitle", "客源手机号验证");
    util.hideLoading();
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    //获得打卡类型及客源编号
    getInfo() {
      let obj = util.urlGet();
      console.log(obj);
      if (obj.type == 1 || obj.type == 2 || obj.type == 3) {
        this.type = obj.type;
      }
      if (obj.dk_method == "bianhao" || obj.dk_method == "phone") {
        console.log(obj.dk_method);
        this.dk_method = obj.dk_method;
      }

      if (obj.dk_code != undefined && obj.dk_code != null) {
        this.phone = obj.dk_code;
      }
    },
    onCancel() {
      Toast("取消");
    },
    onSelect(item) {
      this.keyuanNum = item.name;
    },
    inputChange(event) {
      let value = event.target.value;
      this.name = value;
      this.user = null;
      if (!value) return;
      actions
        .searchJinJiRen(
          {
            login_name: value,
          },
          true
        )
        .then((res) => {
          if (res.is_success == 0) {
            this.list = res.content;
          }
        });
    },
    inputChangePhone(event) {
      let value = this.phone;
      if (value.length == 11) {
        console.log(value);
        let type = "";
        if (this.type == 1) {
          type = "新房";
        }
        if (this.type == 2) {
          type = "买卖";
        }
        if (this.type == 3) {
          type = "租赁";
        }
        actions
          .getKybhByPhone({
            userid: util.getLocalStorage("userid"),
            s_dh: value,
            s_jylx: type,
          })
          .then((res) => {
            if (res.is_success == 0) {
              if (res.content.length == 0) {
                // this.keyuanNum = '';
                this.addKeYuanByPhone();
              } else if (res.content.length == 1) {
                if (res.content[0].sfgk != undefined) {
                  this.keyuanNum =
                    res.content[0].bh + "(" + res.content[0].sfgk + ")";
                } else {
                  this.keyuanNum = res.content[0].bh;
                }
              } else if (res.content.length > 1) {
                this.show = true;
                for (let i = 0; i < res.content.length; i++) {
                  if (res.content[i].sfgk != undefined) {
                    res.content[i].name =
                      res.content[i].bh + "(" + res.content[i].sfgk + ")";
                  } else {
                    res.content[i].name = res.content[i].bh;
                  }
                }
                this.keyuanList = res.content;
              }
            }
          });
      }
    },
    addKeYuanByPhone() {
      Dialog.confirm({
        title: "客源标号查询",
        message: "根据电话" + this.phone + "未查询到客源信息，是否新增客源",
      })
        .then(() => {
          let jingjirenID = util.getLocalStorage("userid");
          let data = {
            type: this.type,
            rwfzr: jingjirenID || util.getLocalStorage("xingming"),
            login_id: util.getLocalStorage("xingming"),
            khdh: this.phone,
          };
          actions.addKeYuan(data).then((res) => {
            if (res.is_success == 0) {
              if (res.content.sfgk != undefined) {
                this.keyuanNum = res.content.bh + "(" + res.content.sfgk + ")";
              } else {
                this.keyuanNum = res.content.bh;
              }
            } else {
              util.showToast(res.content);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    select(item) {
      this.user = item;
      this.name = item.login_name;
    },
    commit() {
      let jingjirenID = util.getLocalStorage("userid");
      if (
        jingjirenID == null ||
        jingjirenID == "null" ||
        jingjirenID == undefined
      ) {
        Dialog.confirm({
          title: "警告",
          message: "身份过期null，请重新添加任务，或重新登录",
        });
        return false;
      }

      let data = {
        type: this.type,
        rwfzr: jingjirenID,
        login_name: util.getLocalStorage("xingming"),
      };
      if (this.dk_method == "phone") {
        if (!util.verify.phone.test(this.phone)) {
          return util.showToast("输入正确的手机号");
        }

        if (this.keyuanNum == null) {
          return util.showToast("请选择客源编号");
        }

        data.khdh = this.phone;

        data.add_type = "1";
        let keyuanText = this.keyuanNum + "";
        data.khbh = keyuanText.split("(")[0];
      } else if (this.dk_method == "bianhao") {
        data.add_type = "2";
        if (this.phone == "") return util.showToast("输入客源编号");
        data.khbh = this.phone;
      }

      if (this.method == 1) {
        actions.addRenWu(data).then((res) => {
          if (res.is_success == 0) {
            util.showToast("添加成功");
            this.$router.push({ name: "renwulist" });
          } else {
            // util.showToast(res.is_success);
            Dialog.confirm({
              title: "添加失败",
              message: res.is_success,
            });
          }
        });
      } else {
        if (!this.user) return util.showToast("请选择经纪人");
        data.rwfzr = this.user.login_id;
        actions.add_tiren_renwu(data).then((res) => {
          if (res.is_success == 0) {
            util.showToast("添加成功");
            this.$router.push({ name: "renwulist" });
          } else {
            // util.showToast(res.is_success);
            Dialog.confirm({
              title: "添加失败",
              message: res.is_success,
            });
          }
        });
      }
    },
    gotoRenwu() {
      this.$router.push({ name: "renwulist" });
    },
    changeType() {
      this.keyuanNum = null;
      this.inputChangePhone({});
    },
  },
  watch: {
    type: {
      handler(newVal, oldValue) {
        if (newVal != oldValue) {
          this.changeType();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.container-renwu {
  position: relative;
  font-size: 0.3rem;
  &.no {
    color: #999;
    text-align: center;
  }
  .tabs {
    position: relative;
    display: flex;
    width: 100%;
    line-height: 1rem;
    height: 1rem;
    background-color: #fff;
    .tab {
      flex: 1;
      text-align: center;
      color: #00ae66;
      border: 1px solid #00ae66;
      &.select {
        color: #fff;
        background-color: #00ae66;
      }
    }
  }
  .select-type {
    position: relative;
    display: flex;
    margin-top: 0.3rem;
    align-items: center;
    padding: 0 0.3rem;
    height: 1rem;
    background-color: #fff;
    .control {
      flex: 1;
      text-align: right;
    }
  }
  .input-phone {
    position: relative;
    display: flex;
    margin-top: 0.3rem;
    align-items: center;
    padding: 0 0.3rem;
    height: 1rem;
    background-color: #fff;
    > input {
      flex: 1;
      text-align: right;
      border: none;
      outline: none;
    }
  }
  .from-item {
    position: relative;
    display: flex;
    margin-top: 0.3rem;
    align-items: center;
    padding: 0 0.3rem;
    height: 1rem;
    background-color: #fff;
    .from-lable {
      width: 2rem;
    }
    .from-control {
      flex: 1;
      text-align: right;
      input {
        text-align: right;
      }
    }
  }
  .list {
    max-height: 3rem;
    overflow-y: scroll;
    background-color: #fff;
    border-top: 1px solid #efefef;
    .item {
      display: flex;
      height: 0.8rem;
      align-items: center;
      padding: 0 0.3rem;
      border-bottom: 1px solid #efefef;
      .name {
        display: inline-block;
      }
      .phone {
        display: inline-block;
        padding-left: 0.3rem;
        font-size: 0.24rem;
        color: #999;
      }
    }
  }
  .btn-commit {
    width: 80%;
    margin: 0.5rem auto 0;
    height: 1rem;
    line-height: 1rem;
    color: #fff;
    background-color: #00ae66;
    text-align: center;
  }
}
</style>
